module.exports = __webpack_public_path__ + "15bac4a5214c6685d272c1ae8f4fac00.svg";